import React, { useCallback, useContext, useMemo, useRef } from 'react'
import { createPortal } from 'react-dom'
import { useHistory, useRouteMatch } from 'react-router-dom'
import Loading from '../../../../molecules/Loading'
import EmptySection from '../../../../atoms/EmptySection'
import SydButton from '../../../../commonDesign/Button'
import OperationalTable from '../../../../organisms/OperationalTable'
import { useListDags, useCreateDag } from '../../../../../api/dags'
import CreateDagDialog from './CreateDagDialog'
import { WorkflowToolbarContext } from './WorkflowManagement'

function WorkflowList () {
  const history = useHistory()
  const { url } = useRouteMatch()
  const { data: dags, isLoading } = useListDags()
  const { mutateAsync: createDag } = useCreateDag()
  const createDialogRef = useRef(null)
  const toolbarNode = useContext(WorkflowToolbarContext)

  const baseUrl = url.replace(/\/list$/, '')

  const handleRowClick = useCallback((row) => {
    history.push(`${baseUrl}/${row.original.dagId}`)
  }, [history, baseUrl])

  const handleNewWorkflow = useCallback(() => {
    createDialogRef.current?.open()
  }, [])

  const handleCreate = useCallback(async (payload) => {
    await createDag(payload)
    history.push(`${baseUrl}/${payload.dagId}/steps`)
  }, [createDag, history, baseUrl])

  const columns = useMemo(() => [
    { id: 'name', accessor: 'name', Header: 'Name' },
    { id: 'dagId', accessor: 'dagId', Header: 'DAG ID' }
  ], [])

  if (isLoading) {
    return <Loading />
  }

  return (
    <>
      {toolbarNode && createPortal(
        <SydButton size='sm' variant='primary' icon='add' onClick={handleNewWorkflow}>
          New Workflow
        </SydButton>,
        toolbarNode
      )}
      {!dags?.length ? (
        <EmptySection
          title='No Workflows'
          description='No DAG definitions found.'
        />
      ) : (
        <OperationalTable
          variant='v2'
          columns={columns}
          data={dags}
          defaultSort={[{ id: 'name', desc: false }]}
          onRowClick={handleRowClick}
        />
      )}
      <CreateDagDialog ref={createDialogRef} onConfirm={handleCreate} />
    </>
  )
}

export default WorkflowList
